module.exports = __webpack_public_path__ + "h5/img/kefu.2c8fd793.png";